import { render, staticRenderFns } from "./AddTextFieldPopup.vue?vue&type=template&id=879af322&"
import script from "./AddTextFieldPopup.vue?vue&type=script&lang=js&"
export * from "./AddTextFieldPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports